const oldLogoClubIds = [8661, 259];

export default oldLogoClubIds;
